import axios from 'axios';

const apiClient = axios.create({
  baseURL: (process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1') + '',
});

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers = config.headers ?? {};
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (!originalRequest || error.response?.status !== 401) {
      return Promise.reject(error);
    }

    if (originalRequest._retry) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      localStorage.removeItem('access_token');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
      return Promise.reject(error);
    }

    try {
      const refreshResponse = await axios.post((process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1') + '/auth/refresh', {
        refresh_token: refreshToken,
      });
      const newAccessToken: string | undefined = refreshResponse.data?.data?.access_token;
      if (!newAccessToken) {
        throw new Error('No access_token in refresh response');
      }

      localStorage.setItem('access_token', newAccessToken);

      originalRequest.headers = originalRequest.headers ?? {};
      originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;

      return apiClient(originalRequest);
    } catch (refreshError) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
      return Promise.reject(refreshError);
    }
  },
);

export default apiClient;
